import React from 'react';
import { Card, CardContent, Typography } from '@mui/material';

const QRCodeDisplay = ({ qrImage, qrCode }) => (
  <Card>
    <CardContent>
      <Typography variant="h6">QR Code</Typography>
      <img src={qrImage} crossOrigin="anonymous" alt="QR" width="200" />
      <Typography>
        <a href={qrCode} target="_blank" rel="noopener noreferrer">
          Open QR Page
        </a>
      </Typography>
    </CardContent>
  </Card>
);

export default QRCodeDisplay;
